import books from './books.json';
import listening from './listening.json';
import learning from './learning.json';
import races from './races.json';

/**
 * One definition of the shelf.
 *
 * These four files used to be read by three separate surfaces — the
 * homepage "currently" card, /now, and /log — each with its own copy of
 * the filtering logic and its own labels. /now is gone; the other two
 * now share this.
 */
export const LOG = { books, listening, learning, races };

export const CATEGORIES = [
  {
    id: 'books',
    label: 'Books',
    nowLabel: 'reading',
    activeStatus: 'reading',
    tile: 'read',
    name: (i) => i.title,
    sub: (i) => i.author,
  },
  {
    id: 'listening',
    label: 'Listening',
    nowLabel: 'listening',
    activeStatus: 'ongoing',
    tile: 'listen',
    name: (i) => i.title,
    sub: (i) => i.note,
  },
  {
    id: 'learning',
    label: 'Learning',
    nowLabel: 'learning',
    activeStatus: 'in-progress',
    tile: 'learn',
    name: (i) => i.title,
    sub: (i) => i.context,
  },
  {
    id: 'races',
    label: 'Races',
    nowLabel: 'training for',
    activeStatus: 'upcoming',
    tile: 'train',
    name: (i) => i.name,
    sub: (i) => i.location,
  },
];

export const currentItems = (categoryId) => {
  const category = CATEGORIES.find((c) => c.id === categoryId);
  if (!category) return [];
  return (LOG[categoryId] || []).filter((i) => i.status === category.activeStatus);
};

/** One live item per category, for the homepage strip. */
export const nowRows = () =>
  CATEGORIES.map((category) => {
    const item = currentItems(category.id)[0];
    return item ? { category, item } : null;
  }).filter(Boolean);
